import getDomainFromUrl from "../../utils/get-domain-from-url"
import { FlexibleCard } from "./generic-search-result"

interface WebToolSearchResultSourcesProps {
  results: WebSearchToolInvocationSearchResult[]
}

export default function WebToolSearchResultSources({ results }: WebToolSearchResultSourcesProps) {
  if (!results.length) return null

  return (
    <div className="space-y-4">
        {results.map((result, idx) => {
          const relevancePercentage = Math.trunc(result.score * 100)
          return (
            <FlexibleCard
              type="web"
              title={result.title}
              domain={getDomainFromUrl(result.url)}
              url={result.url}
              content={result.content}
              relevancePercentage={relevancePercentage}
              idx={idx}
            />
          )
        })}
    </div>
  )
}
